var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512.0 512.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "scale(0.125 0.125) translate(2048.0 2048.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-89.827,687.647 C-80.1263,916.024 -256.649,1108.21 -485.026,1117.91 L-1172.91,1147.13 L-1161.22,1422.28 L-473.339,1393.06 C-93.6264,1376.93 201.456,1055.67 185.327,675.959 L156.108,-11.926 L-119.046,-0.238364 L-89.827,687.647 Z ",
    fill: "#a9ebfa",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.829,870.641 C574.463,803.105 688.211,707.137 775.464,597.769 M902.14,385.011 C919.17,339.057 937.954,296.652 949.681,248.904 M977.905,78.1855 C982.656,7.38942 984.734,-59.878 974.432,-129.858 C964.292,-235.246 932.92,-343.387 882.049,-446.306 C811.881,-588.263 714.159,-705.56 595.062,-794.628 M443.229,-887.387 C370.8,-922.243 300.983,-947.349 225.822,-965.398 M132.956,-983.528 C38.2963,-996.354 -58.1991,-995.026 -156.53,-979.543 M-432.226,-894.054 C-515.626,-852.831 -587.562,-801.818 -650.668,-746.338 C-725.317,-682.944 -790.298,-604.457 -839.369,-520.586 C-916.077,-394.35 -963.658,-249.392 -974.954,-102.496 C-987.76,-12.2624 -981.986,79.8272 -963.81,170.203 M-875.569,424.667 C-794.876,587.917 -675.085,718.594 -535.653,813.066 C-481.825,850.493 -420.003,881.759 -357.263,905.947 C-313.961,922.08 -269.762,935.56 -222.013,947.287 C-145.975,967.11 -68.1015,972.779 13.3413,972.267 C85.9321,971.714 159.461,959.658 235.661,944.073 ",
    fill: "none",
    strokeWidth: 30,
    stroke: "#f25d5a",
    strokeLinecap: "square",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.277,-699.573 C111.576,-927.95 288.099,-1120.13 516.477,-1129.83 L1204.36,-1159.05 L1192.67,-1434.21 L504.789,-1404.99 C125.077,-1388.86 -170.006,-1067.6 -153.877,-687.885 L-124.658,1.13687e-13 L150.496,-11.6876 L121.277,-699.573 Z ",
    fill: "#a9ebfa",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/soundOff.7ce2cccc10d4940ea5da7fafa64a9e9a.svg";
export { ForwardRef as ReactComponent };